export default "__VITE_ASSET__DMGavpt7__"